module.exports = __webpack_public_path__ + "img/return-green.e2fe7320.svg";